<template>
  <div class="container">
    <div class="row" style="margin: 0">
      <div class="col-md-12 col-xs-12 main-block">
        <div class="form-signin-heading text-center signin-text" style="margin-top: 50px;" v-html="loginTitle">
        </div>
        <div class="form-signin">
          <slot name="before"/>
          <div class="row">
            <TitleLogo :url="url + 'login'" />
          </div>
          <template v-if="isEmailAuthAcceptMethod">
            <accept-login-email :login="form.login" />
          </template>
          <template v-else-if="isPhoneAuthAcceptMethod">
            <accept-login-phone :user-id="userId"/>
          </template>
          <template v-else>
            <div v-if="errors.length > 0" class="alert alert-danger">
              <div v-for="(errorMessage, index) in errors" :key="index" v-html="errorMessage"></div>
            </div>
            <div class="form-group">
              <input
                v-model="form.login"
                id="inputEmail"
                type="text"
                class="form-control"
                :placeholder="$t('Enter your phone number or email. address')"
                required
                autofocus
              />
            </div>
            <div class="form-group">
              <input
                v-model="form.password"
                id="inputPassword"
                type="password"
                class="form-control"
                name="password"
                :placeholder="$t('Enter password (optional)')"
              />
            </div>
            <div class="row form-signin-buttons">
              <div class="col-md-6">
                <input
                  id="buttonPassword"
                  type="submit"
                  class="btn btn-md btn-primary btn-block btn-primary-blue"
                  :value="$t('Log in with a password')"
                  :disabled="disabledButtons"
                  @click="login"
                />
              </div>
              <div class="col-md-6">
                <input
                  id="buttonLink"
                  type="submit"
                  class="btn btn-md btn-primary btn-block btn-primary-blue"
                  name="send_me"
                  :value="$t('Login without password')"
                  :disabled="disabledButtons"
                  @click="loginNoPassword"
                />
              </div>
            </div>
            <p class="text-center note-signin">
              <br/>{{ $t('Entrance info') }}
            </p>
          </template>
          <slot name="after"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '../../helpers/api-client/ApiClient'
import { ResponseStatuses } from '../../enums/ResponseStatuses'
import { AuthAcceptMethods } from '../../enums/AuthAcceptMethods'
import AcceptLoginPhone from './AcceptLoginPhone.vue'
import TitleLogo from '../TitleLogo'
import AcceptLoginEmail from './AcceptLoginEmail'
import store from '@/store'
import { UserRoles } from '@/enums/UserRoles'

export default {
  name: 'LoginForm',

  components: {
    AcceptLoginEmail,
    TitleLogo,
    AcceptLoginPhone
  },

  data: () => ({
    authAcceptMethod: AuthAcceptMethods.Default,
    disabledButtons: false,
    errors: [],
    userId: null,
    form: {
      login: null,
      password: null
    },
    url: process.env.BASE_URL
  }),

  computed: {
    loginTitle () {
      return this.$t('Registration of applications for the services of the State Enterprise "Kazakhstan Su Zholdary" (KSZH)')
    },

    error () {
      return this.errors.join('\n')
    },

    isDefaultAuthAcceptMethod () {
      return this.authAcceptMethod === AuthAcceptMethods.Default
    },

    isEmailAuthAcceptMethod () {
      return this.authAcceptMethod === AuthAcceptMethods.Email
    },

    isPhoneAuthAcceptMethod () {
      return this.authAcceptMethod === AuthAcceptMethods.Phone
    }
  },

  methods: {
    async login () {
      this.disabledButtons = true

      ApiClient.login(this.form)
        .then(async (response) => {
          const data = response.data
          this.errors = data.errors

          if (data.status === ResponseStatuses.Success) {
            await this.$store.dispatch('authorize', data.data)

            await this.$router.push('/')
          }
        })
        .finally(() => {
          this.disabledButtons = false
        })
    },

    async loginNoPassword () {
      this.disabledButtons = true

      ApiClient.loginNoPassword(this.form)
        .then(({ data }) => {
          this.errors = data.errors

          if (data.status === ResponseStatuses.Success) {
            this.authAcceptMethod = data.accept_method
            this.userId = data.data.user_id
          }
        })
        .finally(() => {
          this.disabledButtons = false
        })
    }
  }
}
</script>
